site.megamenu = {
	init:function() {
		//site.megamenu.extra();
		$('#mainmenu .mmLevel1').on('click', function(e) {
			e.stopPropagation();
		});
		$('.level1.children > a','#mainmenu').on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', '#mainmenu').removeClass('open');
					$(this).parent().addClass('open');
				}

				$('body.megamenu-open').on('click', function (e) {
					site.megamenu.close();
				});
			}
		});
	},

	close:function() {
		$('body').removeClass('megamenu-open');
		$('.level1.open', '#mainmenu').removeClass('open');
	},
	extra: function() {
		var $menuItem = $('#mainmenu').find('.level1');
		$menuItem.each(function() {
			var $this = $(this);
			var $class = $this.attr('class').split(' ')[0].replace('ele-','');
			$this.find('.mmLevel2').append($('<li class="iconsQn">').load('/_/is/extras/index/index/'+$class));
			/*
			$.ajax({
				type: 'GET',
				url: '/_/is/extras/index/index/'+$class,
				dataType: 'json',
				success: function(r) {
					console.log(r);
				}
			});
			*/
		});
	}
};
